export default __webpack_public_path__ + "static/media/1819 knife block B side.aa8b8980.png";